module.exports = __webpack_public_path__ + "img/location-pin-v2.956d51d2.svg";